module.exports = __webpack_public_path__ + "img/modal-experiencia-2.c1880ada.svg";